import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { canUseDOM } from './utils';

class Portal extends Component {
  componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }
    this.defaultNode = null;
  }

  render() {
    if (!canUseDOM) {
      return null;
    }
    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement('div');
      this.defaultNode.setAttribute('hd-portal-container', '');
      document.body.appendChild(this.defaultNode);
    }
    return ReactDOM.createPortal(this.props.children, this.props.node || this.defaultNode);
  }
}

Portal.propTypes = {
  children: PropTypes.node,
  node: PropTypes.any,
};

export default Portal;
